import React from 'react';

const Play = () => (
    <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <defs />
        <path d="M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0zm-6.575 14.099c-.611-.294-1.425.098-1.425.784v20.194c0 .686.814 1.176 1.425.784l18.117-10.097c.61-.294.61-1.177 0-1.569z" />
    </svg>
);

export default Play;
